/**
 * @generated SignedSource<<11924a9f3b6f8b70f63ad5d7ff67da57>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type GlobalTopNavigation$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useSideNavToggleStateQuery">;
  readonly " $fragmentType": "GlobalTopNavigation";
};
export type GlobalTopNavigation$key = {
  readonly " $data"?: GlobalTopNavigation$data;
  readonly " $fragmentSpreads": FragmentRefs<"GlobalTopNavigation">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "GlobalTopNavigation",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "useSideNavToggleStateQuery"
    }
  ],
  "type": "Query"
};

(node as any).hash = "1bb90f1e5d3bf76aeaee25ec68726bfc";

export default node;
